import React, { useState } from "react";
import Modal from "react-modal";
import TMEGymwiseAnalysis from "./TMEGymwiseAnalysis";
import TMETrainerwiseAnalysis from "./TMETrainerwiseAnalysis";
import DetailModHeader from "../../common-components/DetailModHeader";
import TMEAnalysisDetailed from "./TMEAnalysisDetailed";
import TMEGymAnalysisDetails from "./tme-checkin-analysis/TMEGymAnalysisDetails";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import MemberAllProfiles from "../trainer-member-map/MemberAllProfiles";

const TMEAnalysis = ({ userInfoData, allFilters }) => {
  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",

    isModOpen2: false,
    modName2: "",
    rowData2: "",
  };
  const [modValues, setModValues] = useState(iniModValues);
  // const [refreshKey, setRefreshKey] = useState(0);

  const onCloseModal = () => {
    setModValues(iniModValues);
    // setRefreshKey((prev) => prev + 1);
  };

  const onCloseModal2 = () => {
    setModValues((prevs) => ({
      ...prevs,
      isModOpen2: false,
      modName2: "",
      rowData2: "",
    }));
  };

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Detailed Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.modName === "tme-analysis-details" ||
            modValues.modName === "tme-gym-analysis-details"
              ? "mod-width-70p mod-min-height-95vh"
              : ""
          }`}
        >
          {modValues.modName === "tme-gym-analysis-details" ? (
            <ModalHeadAndClose
              title={modValues.rowData?.gym_name || "Gym Details"}
              onClose={onCloseModal}
            />
          ) : (
            <DetailModHeader
              from="tme-analysis"
              info={modValues.rowData}
              onClose={onCloseModal}
              isOnlySubscription={true}
            />
          )}

          {modValues.modName === "tme-analysis-details" ? (
            <TMEAnalysisDetailed
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              setModValues={setModValues}
            />
          ) : modValues.modName === "tme-gym-analysis-details" ? (
            <TMEGymAnalysisDetails
              from={modValues.modName}
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              setModValues={setModValues}
            />
          ) : null}
        </div>
      </Modal>

      <Modal
        isOpen={modValues.isModOpen2}
        onRequestClose={onCloseModal2}
        contentLabel="Detailed Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.modName2 === "tme-analysis-details"
              ? "mod-width-70p mod-min-height-95vh"
              : modValues.modName2 === "member_view_details"
              ? "bg-white mod-min-height-95vh mod-width-70p"
              : ""
          }`}
        >
          <DetailModHeader
            from={
              modValues.modName2 === "tme-analysis-details"
                ? "tme-analysis"
                : ""
            }
            info={modValues.rowData2}
            onClose={onCloseModal2}
            isOnlySubscription={true}
          />

          {modValues.modName2 === "tme-analysis-details" ? (
            <TMEAnalysisDetailed
              userInfoData={userInfoData}
              rowData={modValues.rowData2}
              setModValues={setModValues}
            />
          ) : modValues.modName2 === "member_view_details" ? (
            <MemberAllProfiles
              rowData={modValues.rowData2}
              userInfoData={userInfoData}
            />
          ) : null}
        </div>
      </Modal>

      <div className="flex-between-tables-container mt30">
        <TMEGymwiseAnalysis
          // key={`gymwise-${refreshKey}`}
          userInfoData={userInfoData}
          allFilters={allFilters}
          setModValues={setModValues}
        />

        <TMETrainerwiseAnalysis
          // key={`trainerwise-${refreshKey}`}
          userInfoData={userInfoData}
          allFilters={allFilters}
          setModValues={setModValues}
        />
      </div>
    </>
  );
};

export default TMEAnalysis;
